// highlighting for student view
export const HIGHLIGHT_TODO = 'HIGHLIGHT_TODO'
// export const UNHIGHLIGHT_TODO = "UNHIGHLIGHT_TODO";

// irestore setup and cleanup
export const BEGIN_INITIALIZATION = 'BEGIN_INITIALIZATION'
export const INITIALIZE_VIEW_TYPE = 'INITIALIZE_VIEW_TYPE'
export const ADD_FIRESTORE_UNLISTENER = 'ADD_FIRESTORE_UNLISTENER'
export const COMPLETE_LIST_INFO_LOAD = 'COMPLETE_LIST_INFO_LOAD'
export const COMPLETE_TODO_ITEM_LOAD = 'COMPLETE_TODO_ITEM_LOAD'
export const END_INITIALIZATION = 'END_INITIALIZATION'
export const CLEAR_ALL = 'CLEAR_ALL'

// actions resulting from firestore listening
export const SET_TITLE_VIA_FIREBASE = 'SET_TITLE_VIA_FIREBASE'
export const SET_DESCRIPTION_VIA_FIREBASE = 'SET_DESCRIPTION_VIA_FIREBASE'
export const ADD_TODO_VIA_FIREBASE = 'ADD_TODO_VIA_FIREBASE'
export const MODIFY_TODO_VIA_FIREBASE = 'MODIFY_TODO_VIA_FIREBASE'
export const REMOVE_TODO_VIA_FIREBASE = 'REMOVE_TODO_VIA_FIREBASE'



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js